import { useDataFormat } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let account_id = useDataFormat({
    context: 'selected',
    path: 'required.data',
    viewPath: props.viewPath,
    format: array => {
      if (!array?.length) {
        return null
      }

      return array?.find(item => item.key === 'account_id')?.value
    },
  })

  return {
    variables: { account_id },
    pause: !account_id,
  }
}
